import { createContext, useContext, type ReactNode } from 'react'

import { useLocaleStorage } from '../i18n/detect-locale'

type LocaleContextValue = {
  locale: string
  setLocale: (locale: string) => void
}

const LocaleContext = createContext<LocaleContextValue | null>(null)

type LocaleProviderProps = {
  children: ReactNode
}

export const LocaleProvider = ({ children }: LocaleProviderProps): JSX.Element => {
  const [locale, setLocale] = useLocaleStorage()
  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  )
}

export const useLocale = (): LocaleContextValue => {
  const value = useContext(LocaleContext)
  if (value === null) {
    throw new Error('useLocale must be used within LocaleProvider')
  }
  return value
}
